/* -----------------------------------
 *
 * Component
 *
 * -------------------------------- */
/* -----------------------------------
 *
 * Options
 *
 * -------------------------------- */
/* -----------------------------------
 *
 * Errors
 *
 * -------------------------------- */
var ErrorTypes = /*#__PURE__*/function (ErrorTypes) {
  ErrorTypes["Promise"] = "Error: Promises cannot be used for SSR";
  ErrorTypes["Missing"] = "Error: Cannot find component in provided function";
  ErrorTypes["Json"] = "Error: Invalid JSON string passed to component";
  ErrorTypes["Tag"] = "Error: Invalid tag name for custom element. Must include a `-`";
  return ErrorTypes;
}(ErrorTypes || {});
/* -----------------------------------
 *
 * Element
 *
 * -------------------------------- */
/* -----------------------------------
 *
 * IProps
 *
 * -------------------------------- */
/* -----------------------------------
 *
 * Guards
 *
 * -------------------------------- */

const isPromise = input => {
  return input && typeof input.then === 'function';
};

/* -----------------------------------
 *
 * Self Closing
 *
 * -------------------------------- */

const selfClosingTags = ['area', 'base', 'br', 'col', 'hr', 'img', 'input', 'link', 'meta', 'source', 'embed', 'param', 'track', 'wbr'];

/* -----------------------------------
 *
 * Export
 *
 * -------------------------------- */

export { ErrorTypes, isPromise, selfClosingTags };